const timetableview = {
    namespaced: true,
    state: {
        views: [],
        stops: {}
    },
    mutations: {
        updateTimetableViews(state, newList) {
            state.views = newList;
        },
        updateStops(state, newList) {
            state.stops = newList;
        }
    },
    actions: {
        list(context) {
            this._vm.$traveller_http.get('/traveller/restui/content/timetableview/list')
            .then(function(response) {
                context.commit('updateTimetableViews', response.data);
            })
            .catch(error => {
                console.warn('Failed to load timetable views:', error);
            });
        },
        stops(context) {
            this._vm.$traveller_http.get('/traveller/restui/content/timetableview/stops')
            .then(response => {
                context.commit('updateStops', response.data);
            });
        },
        save(context, item) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/content/timetableview/save', item)
                .then(response => {
                    loadListIfNeeded(response, context);
                    resolve(response);
                }).catch( error => {
                    reject(error);
                })
            });
        },
        saveSettings(context, item) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.post('/traveller/restui/content/timetableview/saveSettings', item)
                .then(response => {
                    loadListIfNeeded(response, context);                   
                    resolve(response);
                }).catch( error => {
                    reject(error);
                })
            });
        },


        delete(context, id) {
            return new Promise((resolve, reject) => {
                this._vm.$traveller_http.get('/traveller/restui/content/timetableview/delete', { params: { "id": id } })
                .then(response => {
                    loadListIfNeeded(response, context);
                    resolve(response);
                }).catch( error => {
                    reject(error);
                })
            });
        },
      
    },
        getters: {
        getTimeTableViewByID: (state) => (id) => {
            return Array.isArray(state.views) ? state.views.find(timetableview => timetableview.id === id) : undefined;
        }
    }
}



export default timetableview;

function loadListIfNeeded(response, context) {
    if (response.status == 200) {
        context.dispatch('list');
    }
}
